import { WebStorageStateStore } from 'oidc-client-ts';
import type { UserManagerSettings } from 'oidc-client-ts';
import { cognitoAuthority } from './authority';

export const oidcConfig: UserManagerSettings = {
  // Cognito OIDC discovery URL — swap this for any OIDC-compliant IdP.
  // Single-sourced in authority.ts: sign-out reads the SAME discovery document to
  // find /logout, and the two must never disagree (docs/29 F15).
  authority: cognitoAuthority(),
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: `${window.location.origin}/login`,
  scope: 'openid email profile',
  response_type: 'code',
  // oidc-client-ts v3 defaults to sessionStorage; use localStorage so Playwright
  // storageState captures the oidc user token across browser contexts
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};
